module.exports = __webpack_public_path__ + "media/images/design_pin_logo@2x-9f526bc7aec40a68f151fc2fc4b7a6a6.png";